import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { ProductService } from 'src/app/market-place/services/product.service';
import { AdminServiceService } from 'src/app/admin/service/admin-service.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
  @Input() class: string = '';
  @Input() events: Observable<boolean>;
  @Output() setCategories: any = new EventEmitter();

  categorie: any;
  constructor(
    private productsService: ProductService,
    private router: Router,
    private route: ActivatedRoute,
    private adminSv: AdminServiceService
  ) {}
  isCollapsed: boolean = true;
  categorias = [];
  results!: any;
  desde: number = 0;
  hasta: number = 0;
  fechaPublicacion = [
    {
      fecha: 'Mas recientes',
    },
    {
      fecha: 'Más antiguos',
    },
  ];

  estados = [
    {
      estado: 'Todos',
    },
    {
      estado: 'Nuevo',
    },
    {
      estado: 'Usado',
    },
  ];

  filtros: any = {
    categoria: 'todos',
    fecha: 'mas-recientes',
    estado: 'todos',
    metodo: 'todos',
    setPrice: '0',
  };
  setPrices: boolean = false;

  async ngOnInit() {
    console.log('a');
    
    this.categorie = this.route.snapshot.queryParamMap.get('categoria');
    this.route.queryParamMap.subscribe((query: any) => {
      this.filtros.s = query.params.s ? query.params.s : 'todos';
    });

    const res: any = await this.adminSv.getAllCategories('index', {});
    const data = res.data.map(category => { 
      return { categoria: category.name, id: category.id }
    });
    this.categorias = data;
    // .subscribe((res: any) => {
    //   res.data.forEach((category) => {
    //     const data = {
    //       categoria: category.name,
    //       id: category.id,
    //     };
    //     this.categorias.push({ ...data });
    //   });
    // });
    this.results = [...this.categorias];
  }

  optFilt(ev:any){
    const regexs = /[A-Záéíóú]\w+/gi;
    const query = ev.target.value.toLowerCase().trim();
    if(query && regexs.test(query)){
      this.results = this.categorias.filter((d) => d.categoria.toLowerCase().indexOf(query) > 0);
    }else{
      this.results = this.categorias;
    }
  }

  async showFilter(popover: boolean) {
    const accordion = document.getElementById(
      'accordion'
    ) as HTMLIonAccordionElement;

    if (popover) {
      accordion.classList.remove('accordion-group-collapsed');
    } else {
      if (this.isCollapsed) {
        accordion.classList.add('accordion-group');
      } else {
        accordion.classList.remove('accordion-group');
      }
    }

    this.isCollapsed = !this.isCollapsed;
  }

  filtrosCambio(event) {
    const name = event.target.name;
    const value = event.detail.value;
    
    if (!this.setPrices) {
      delete this.filtros.desde;
      delete this.filtros.hasta;
    }

    if (name === 'setPrice') {
      this.filtros[name] = value;
      if (this.setPrices) {
        this.filtros.desde = this.desde;
        this.filtros.hasta = this.hasta;
      } else if (!Number(value)) {
        delete this.filtros.desde;
        delete this.filtros.hasta;
      }
    } else if (!name.includes('ion-cb-0')) {
      this.filtros[name] = value;
    }
  }

  setFiltos() {
    this.setCategories.emit(this.filtros);
    const urlTree = this.router.createUrlTree([], {
      queryParams: this.filtros,
    });

    this.router.navigateByUrl(urlTree);
  }
}
